import * as React from 'react';
import { NotesEditor } from 'notes-editor';
import { Dispatch } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { StoreState } from '../../reducers';
import Portal from '../Portal';
import { Wrapper } from './styles';
import { createNote, updateNote, toggleNotesEditor } from '../../containers/NotesPage/actions';
import IndexedDBManager from '../../utils/indexedDB/manager';
import useClickOutside from '../../utils/customHooks/useClickOutside';
import { Api } from '../../typings/api';

interface NotesEditorPanelProps {
	isOpened: boolean;
	locale: string;
	noteId: number | undefined;
	dispatch: Dispatch<StoreState>;
}

const NotesEditorPanel = ({
	isOpened,
	locale,
	noteId,
	dispatch,
}: NotesEditorPanelProps) => {
	const DEFAULT_TITLE = I18n.t('messages.untitled_note');
	const noteTitle = React.useRef(DEFAULT_TITLE);
	const editorElement = React.useRef<HTMLDivElement>(null);
	useClickOutside(editorElement, isOpened, () => dispatch(toggleNotesEditor()));

	React.useEffect(() => {
		let notesEditor: NotesEditor | undefined;
		const onTitleChange = (value: string) => noteTitle.current = value;
		const onClose = () => dispatch(toggleNotesEditor());

		if (isOpened) {
			if (!noteId) {
				// @ts-ignore
				notesEditor = new NotesEditor(editorElement.current as HTMLDivElement, onTitleChange, noteTitle.current, '', '', locale, onClose);
			} else {
				IndexedDBManager.getNote(noteId).then(note => {
					if (note) {
						const { title, content, drawing } = note;
						noteTitle.current = title;
						// @ts-ignore
						notesEditor = new NotesEditor(editorElement.current as HTMLDivElement, onTitleChange, title, content, drawing, locale, onClose);
					}
				});
			}
		}

		return () => {
			if (!notesEditor) {
				return;
			}

			const { text, image } = notesEditor.getDataToSave();
			const shouldCreateNote = !noteId && (text.plainText || image);

			if (noteId) {
				dispatch(updateNote(noteId, {
					title: noteTitle.current,
					content: text.formattedText,
					drawing: image,
				} as Api.NoteData));
			} else if (shouldCreateNote) {
				dispatch(createNote(noteTitle.current, text, image));
			}

			noteTitle.current = DEFAULT_TITLE;
			notesEditor.destroy();
		};
	}, [isOpened, noteId, locale]);

	React.useEffect(() => {
		noteTitle.current = DEFAULT_TITLE;
	}, [locale]);

	return (
		<>
			{isOpened &&
				<Portal parentNode={document.body}>
					<Wrapper ref={editorElement} data-gallery-slot="notesEditorPanel" />
				</Portal>
			}
		</>
	);
};

export default NotesEditorPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesEditorPanel/index.tsx